<script setup lang="ts">
import { FOOTER_SOCIALS, FOOTER_LINKS } from '../lib/constants';
import FooterAction from './FooterAction.vue';
import MenuLinksFooter from '~/widgets/footer/ui/MenuLinksFooter.vue';

const currentYear = computed(() => new Date().getFullYear());
</script>

<template>
  <div :class="$style.footer">
    <!-- <BannerFooter v-if="false" :class="$style.footer__banner" /> -->
    <div :class="$style.footer__top">
      <div :class="$style.footer__visual">
        <NuxtLink :class="$style.footer__logo" to="/" />

        <div :class="$style.footer__icons">
          <NuxtLink
            v-for="(item, key) in FOOTER_SOCIALS"
            :key="`footerSocials_${key}`"
            :class="$style.footer__iconsItem"
            :to="item.link"
            target="_blank"
          >
            <Icon
              :class="$style.footer__iconsItemSvg"
              :name="`my-icon:i-social-${item.name}`"
            />
          </NuxtLink>
        </div>
      </div>
      <div :class="$style.footer__info">
        <div :class="$style.footer__actions">
          <FooterAction
            :class="$style.footer__actionsItem"
            title="Есть новость или&nbsp;предложение?"
            action="Предложить новость"
            link="mailto:news@cre.ru"
          />
          <FooterAction
            :class="$style.footer__actionsItem"
            title="Получить доступ к CRE&nbsp;+"
            action="Войти"
            link="https://cre.ru/user/login"
          />
        </div>
        <MenuLinksFooter :class="$style.footer__menu" />
      </div>
    </div>
    <div :class="$style.footer__bottom">
      <div :class="$style.footer__bottomCopyright">
        © 2002 - {{ currentYear }} CRE
      </div>
      <div :class="$style.footer__bottomLinks">
        <NuxtLink
          v-for="(item, key) in FOOTER_LINKS"
          :key="`footerLinks_${key}`"
          :to="item.link"
          :class="$style.footer__bottomLinksItem"
          >{{ item.title }}</NuxtLink
        >
      </div>
      <div :class="$style.footer__bottomAge">16+</div>
    </div>
  </div>
</template>

<style module lang="scss">
.footer {
  background: var(--color-gray-bg);
  height: 100%;
  border-top: 1px solid var(--color-gray-line);

  &__banner {
    width: 100%;
    background: #fff;
    border-bottom: 1px solid var(--color-gray-line);
  }

  &__top {
    display: flex;
    flex-flow: row nowrap;
    height: 100%;
  }

  &__visual {
    display: flex;
    padding: var(--space-2-5x);
    width: 300px;
    flex-flow: column nowrap;
    flex-shrink: 0;
    justify-content: space-between;
    border-right: 1px solid var(--color-gray-line);
  }

  &__logo {
    display: block;
    width: 205px;
    height: 48px;
    background: url('images/logo.svg') no-repeat left center / auto 48px;
    cursor: pointer;
  }

  &__icons {
    display: flex;
    flex-flow: row wrap;
    gap: var(--space-1-5x);

    &Item {
      width: 48px;
      height: 48px;
      background: rgba(0, 0, 0, 0.2);

      &Svg {
        width: 48px;
        height: 48px;
      }
    }
  }

  &__actions {
    display: flex;
    flex-flow: row nowrap;
    border-bottom: 1px solid var(--color-gray-line);

    &Item {
      width: 50%;
      padding: var(--space-2-5x) var(--space-4x);

      &:nth-child(1) {
        border-right: 1px solid var(--color-gray-line);
      }
    }
  }

  &__info {
    width: 100%;
  }

  &__menu {
    padding: var(--space-4x);
  }

  &__links {
    border-top: 1px solid var(--color-gray-line);
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    padding: var(--space-4x);
    width: 100%;
    gap: var(--space-5x);
    flex-grow: 1;
  }

  &__bottom {
    display: flex;
    flex-flow: row nowrap;
    border-top: 1px solid var(--color-gray-line);
    padding: 21px var(--space-2-5x);
    width: 100%;
    justify-content: space-between;

    &Copyright {
      width: 300px;
      color: var(--color-gray-text);
    }

    &Links {
      margin-right: auto;
      display: flex;
      flex-flow: row nowrap;
      gap: var(--space-5x);

      &Item {
        @include text_body1;
        color: var(--color-gray-text);
        text-decoration: none;
        border-bottom: 1px solid var(--color-gray-line);
      }
    }

    &Age {
      @include text_body1_large_medium;
      color: var(--color-gray-text);
    }
  }
}

@media (max-width: 1379px) {
  .footer {
    &__actions {
      flex-direction: column;
      &Item {
        width: 100%;
        justify-content: space-between;
        padding: var(--space-2-5x);

        &:nth-child(1) {
          border-right: none;
          border-bottom: 1px solid var(--color-gray-line);
        }
      }
    }

    &__visual {
      width: 208px;
    }

    &__logo {
      background-size: auto 40px;
      width: 180px;
    }

    &__icons {
      &Item {
        width: 47px;
        height: 47px;
      }
    }
  }
}

@media (max-width: 1379px) {
  .footer {
    &__bottom {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, auto);
      row-gap: var(--space-1-5x);
      &Copyright {
        width: 100%;
        grid-column: 2 / 1;
        grid-row: 2;
      }

      &Links {
        grid-column: 1 / -1;
        margin-right: unset;
        justify-content: space-between;
        grid-row: 1;
        &Item {
          @include text_body2;
        }
      }

      &Age {
        grid-column: 2 / 2;
        grid-row: 2;
        text-align: right;
      }
    }

    &__menu {
      padding: var(--space-2-5x);
    }
  }
}

@media (max-width: 767px) {
  .footer {
    &__banner {
      height: 250px;
    }

    &__top {
      flex-direction: column;
    }

    &__visual {
      width: 100%;
      border-right: 0;
      gap: var(--space-2-5x);
    }

    &__logo {
      width: 100%;
      background-position: center;
    }

    &__icons {
      justify-content: space-between;
    }

    &__bottom {
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: repeat(3, auto);
      row-gap: 10px;
      &Copyright {
        grid-column: 1;
        grid-row: 2;
        margin: 0 auto;
        text-align: center;
      }

      &Links {
        flex-direction: column;
        gap: 10px;
        grid-column: 1;
        grid-row: 1;
        margin-left: auto;
        margin-right: auto;
        &Item {
          text-align: center;
        }
      }

      &Age {
        grid-column: 1;
        grid-row: 3;
        text-align: center;
      }
    }
  }
}

@media (max-width: 599px) {
  .footer {
    &__icons {
      gap: var(--space-1x);
      &Item {
        width: 40px;
        height: 40px;
        &Svg {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
}

@media (max-width: 479px) {
  .footer {
    &__visual {
      padding: var(--space-2x);
    }

    &__actions {
      &Item {
        padding: var(--space-2x);
      }
    }

    &__menu {
      padding: var(--space-2x);
    }
  }
}
</style>
